import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import styled from 'styled-components';
import '../layout/Box.js';
import '../layout/Stack.js';
import { AnimatedBox } from '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
var commonStyle = {
  position: "absolute",
  top: "0",
  height: "100%",
  zIndex: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var InputRightElement = styled(AnimatedBox)(__assign(__assign({}, commonStyle), {
  right: "16px"
}));
var InputLeftElement = styled(AnimatedBox)(__assign(__assign({}, commonStyle), {
  left: "16px"
}));
export { InputLeftElement, InputRightElement };